import React, { useEffect } from 'react';
import { string } from 'prop-types';
import { useHelmet, TitleTag, MetaTag, LinkTag } from '@thd-nucleus/thd-helmet';

const HD_URL = 'https://www.homedepot.com';

const rebateCenterMetadataHandler = ({ props }) => {
  const tags = [];
  const {
    alternateUrlEnCa = '',
    alternateUrlFrCa = '',
    data,
    description = '',
    title = ''
  } = props;

  const dataKeys = data && Object.keys(data);

  if (alternateUrlEnCa) {
    tags.push(new LinkTag({
      rel: 'alternate',
      href: alternateUrlEnCa,
      hreflang: 'en-ca',
      id: 'alternate-en-ca'
    }));
  }
  if (alternateUrlFrCa) {
    tags.push(new LinkTag({
      rel: 'alternate',
      href: alternateUrlFrCa,
      hreflang: 'fr-ca',
      id: 'alternate-fr-ca'
    }));
  }

  if (title) tags.push(new TitleTag(title));
  if (description) tags.push(new MetaTag({ name: 'description', content: description, id: 'prop-description' }));

  if (!dataKeys?.length) return tags;

  dataKeys.forEach((tag) => {
    const content = data[tag] || '';

    if (tag === '__typename') {
      return;
    }
    if (tag === 'canonicalURL') {
      tags.push(new LinkTag({ rel: 'alternate', href: `${HD_URL}${content}`, hreflang: 'en', id: 'alternate-en' }));
      tags.push(new MetaTag({ property: 'og:url', content: `${HD_URL}${content}`, id: tag }));
    } else if (tag === 'siteName') {
      tags.push(new MetaTag({ property: 'og:site_name', content, id: tag }));
    } else if (tag === 'fbAdmins') {
      tags.push(new MetaTag({ property: 'fb:admins', content, id: tag }));
    } else {
      tags.push(new MetaTag({ property: `og:${tag}`, content, id: tag }));
    }
  });

  if (data.title) tags.push(new TitleTag(data.title));

  if (data.canonicalURL) {
    tags.push(new LinkTag({ rel: 'canonical', href: `${HD_URL}${data.canonicalURL || ''}`, id: 'canonical' }));
  }

  return tags;
};

const RebateCenterMetadata = (props) => {
  useHelmet('rebateCenterMetadata', { props }, rebateCenterMetadataHandler, [props]);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('rebatecenter-metadata.ready');
  }, []);

  return null;
};

RebateCenterMetadata.displayName = 'RebateCenterMetadata';

export { RebateCenterMetadata };